import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { shopService } from '../services';

const ShopRegistration = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    shopName: '',
    ownerName: '',
    mobile: '',
    address: '',
    products: []
  });
  const [newProduct, setNewProduct] = useState({
    productName: '',
    pricePerUnit: '',
    unit: 'kg'
  });
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleProductChange = (e) => {
    setNewProduct({
      ...newProduct,
      [e.target.name]: e.target.value
    });
  };

  const addProduct = () => {
    if (!newProduct.productName || !newProduct.pricePerUnit) {
      alert('Please fill product name and price');
      return;
    }

    setFormData({
      ...formData,
      products: [...formData.products, { ...newProduct }]
    });

    setNewProduct({
      productName: '',
      pricePerUnit: '',
      unit: 'kg'
    });
  };

  const removeProduct = (index) => {
    setFormData({
      ...formData,
      products: formData.products.filter((_, i) => i !== index)
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.products.length === 0) {
      alert('Please add at least one product');
      return;
    }

    setSubmitting(true);
    setError(null);

    try {
      const response = await shopService.registerShop(formData);
      setResult(response);
    } catch (err) {
      console.error('Registration error:', err);
      setError(err.error || 'Failed to register shop');
    } finally {
      setSubmitting(false);
    }
  };

  if (result) {
    return (
      <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
        <div style={{
          padding: '20px',
          backgroundColor: '#4CAF50',
          color: 'white',
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <h2>Shop Registered Successfully!</h2>
          <p>Shop ID: {result.shopId}</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3>QR Code:</h3>
          <img
            src={result.qrCodeUrl}
            alt="Shop QR Code"
            style={{ maxWidth: '300px', border: '2px solid #ccc', padding: '10px' }}
          />
          <p>
            <a href={result.qrCodeUrl} download={`shop-${result.shopId}-qr.png`}>
              <button style={{
                padding: '10px 20px',
                backgroundColor: '#2196F3',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}>
                Download QR Code
              </button>
            </a>
          </p>
        </div>

        <div style={{ marginTop: '20px' }}>
          <p><strong>Order URL:</strong></p>
          <code style={{
            padding: '10px',
            backgroundColor: '#f5f5f5',
            display: 'block',
            borderRadius: '4px',
            wordBreak: 'break-all'
          }}>
            {result.orderUrl}
          </code>
        </div>

        <button
          onClick={() => navigate('/dashboard')}
          style={{
            marginTop: '20px',
            padding: '12px 30px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Register Chicken Shop</h1>

      {error && (
        <div style={{
          padding: '15px',
          backgroundColor: '#f44336',
          color: 'white',
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Shop Name *
          </label>
          <input
            type="text"
            name="shopName"
            value={formData.shopName}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '16px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Owner Name *
          </label>
          <input
            type="text"
            name="ownerName"
            value={formData.ownerName}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '16px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Mobile Number *
          </label>
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
            placeholder="+91XXXXXXXXXX"
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '16px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Address *
          </label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              minHeight: '80px',
              padding: '10px',
              fontSize: '16px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
        </div>

        <div style={{
          marginBottom: '20px',
          padding: '15px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px'
        }}>
          <h3>Products</h3>

          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', flexWrap: 'wrap' }}>
            <input
              type="text"
              name="productName"
              value={newProduct.productName}
              onChange={handleProductChange}
              placeholder="Product name"
              style={{
                flex: '2',
                padding: '10px',
                fontSize: '16px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                minWidth: '150px'
              }}
            />
            <input
              type="number"
              name="pricePerUnit"
              value={newProduct.pricePerUnit}
              onChange={handleProductChange}
              placeholder="Price"
              step="0.01"
              style={{
                flex: '1',
                padding: '10px',
                fontSize: '16px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                minWidth: '100px'
              }}
            />
            <select
              name="unit"
              value={newProduct.unit}
              onChange={handleProductChange}
              style={{
                flex: '1',
                padding: '10px',
                fontSize: '16px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                minWidth: '80px'
              }}
            >
              <option value="kg">kg</option>
              <option value="gm">gm</option>
              <option value="liter">liter</option>
              <option value="piece">piece</option>
            </select>
            <button
              type="button"
              onClick={addProduct}
              style={{
                padding: '10px 20px',
                backgroundColor: '#2196F3',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Add
            </button>
          </div>

          {formData.products.length > 0 && (
            <table style={{ width: '100%', marginTop: '15px' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '8px' }}>Product</th>
                  <th style={{ textAlign: 'right', padding: '8px' }}>Price</th>
                  <th style={{ textAlign: 'left', padding: '8px' }}>Unit</th>
                  <th style={{ padding: '8px' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {formData.products.map((product, index) => (
                  <tr key={index}>
                    <td style={{ padding: '8px' }}>{product.productName}</td>
                    <td style={{ textAlign: 'right', padding: '8px' }}>₹{product.pricePerUnit}</td>
                    <td style={{ padding: '8px' }}>{product.unit}</td>
                    <td style={{ padding: '8px' }}>
                      <button
                        type="button"
                        onClick={() => removeProduct(index)}
                        style={{
                          padding: '5px 10px',
                          backgroundColor: '#f44336',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px'
                        }}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <button
          type="submit"
          disabled={submitting}
          style={{
            padding: '15px 30px',
            fontSize: '18px',
            backgroundColor: submitting ? '#ccc' : '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: submitting ? 'not-allowed' : 'pointer',
            width: '100%'
          }}
        >
          {submitting ? 'Registering...' : 'Register Shop'}
        </button>
      </form>
    </div>
  );
};

export default ShopRegistration;
